import { makeStyles, shorthands } from "@fluentui/react-components";

const useSecuritiesListStyles = makeStyles({
  selectionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    ...shorthands.margin("5px", "0"),
  },

  selectionHeaderButtons: {
    display: "flex",
    ...shorthands.gap("4px"),
  },

  checkboxesContainer: {
    maxHeight: "210px",
    overflowY: "scroll",
    display: "flex",
    flexDirection: "column",
  },
});

export default useSecuritiesListStyles;
